import { Component, OnInit, Inject , Input} from '@angular/core';

import { LoginService } from '../login/login.service';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'usb-select-agency-modal',
  templateUrl: './select-agency-modal.component.html',
  styleUrls: ['./select-agency-modal.component.scss']
})
export class SelectAgencyModalComponent implements OnInit {

  agency: any;
  @Input() modalRoomRef: BsModalRef;
  @Input() arrayAgencyUser;
  @Input() _data;


  constructor(
    private _loginService: LoginService,
    public _router:Router
  ) { }

  ngOnInit() {
  }


  asignAgency(){
    localStorage.setItem('selectedAgency', JSON.stringify(this.agency));


    this._loginService.updAgency(this.agency).subscribe(
        (response:any) => {
          this._router.navigate(['/select', {}]);
        },
        error => {
          //this.logger.log(error);
        }
      );
    this.modalRoomRef.hide();
  }

  changue(){}

}
